import React, { memo } from 'react';
import { injectIntl } from 'react-intl';
import SentimentSatisfiedAltIcon from '@mui/icons-material/SentimentSatisfiedAlt';
import ScorePanel from '../score-panel';
import { getChartColors } from '../../../../utils/chartTheme';

// Pesos 5/4/3/2/1 (muito bom..muito ruim) — a mesma distribuição percentual do
// gráfico de CSAT já existente (CalledClassificationController/chart/query), só
// que expressa como média ponderada numa escala de 1 a 5 em vez de percentual bruto.
const NOTE_WEIGHTS = [5, 4, 3, 2, 1];

// Vermelho mais fechado que o #E74C3C anterior: naquele tom, texto branco ficava em 3,82:1
// (reprova no AA para o rótulo de 10px) e o texto escuro, apesar de passar, ficava pesado.
// Com este, o branco vai a 5,44:1.
const getScoreColor = score => {
  if (score <= 2) return '#C0392B';
  if (score <= 3) return '#FFBB28';
  if (score <= 4) return '#ece637';
  return '#00C49F';
};

// data: [{ Name, Value }] na ordem Muito bom, Bom, Neutro, Ruim, Muito ruim
// (mesma ordem devolvida por GET /api/calledclassifications/chart/query)
const CsatTable = memo(function CsatTable(props) {
  const { data, intl } = props;
  const colors = getChartColors();

  const values = (data || []).map(item => item.Value || item.value || 0);
  const total = values.reduce((sum, value) => sum + value, 0);
  const weightedSum = values.reduce((sum, value, index) => sum + value * (NOTE_WEIGHTS[index] || 0), 0);
  const score = total > 0 ? (weightedSum / total).toFixed(2) : '0.00';

  const rows = [
    { label: intl.formatMessage({ id: 'agentproductivity.dashboard.csat.verygood', defaultMessage: 'Muito bom' }), color: '#008e7d', value: values[0] || 0 },
    { label: intl.formatMessage({ id: 'agentproductivity.dashboard.csat.good', defaultMessage: 'Bom' }), color: '#52c5a9', value: values[1] || 0 },
    { label: intl.formatMessage({ id: 'agentproductivity.dashboard.csat.neutral', defaultMessage: 'Neutro' }), color: '#ffe234', value: values[2] || 0 },
    { label: intl.formatMessage({ id: 'agentproductivity.dashboard.csat.bad', defaultMessage: 'Ruim' }), color: '#ffa534', value: values[3] || 0 },
    { label: intl.formatMessage({ id: 'agentproductivity.dashboard.csat.verybad', defaultMessage: 'Muito ruim' }), color: '#db324d', value: values[4] || 0 },
  ];

  return (
    <ScorePanel
      id="agent-productivity-csat"
      title={intl.formatMessage({ id: 'agentproductivity.dashboard.csat.title', defaultMessage: 'CSAT (transacional por chamado)' })}
      resultLabel={intl.formatMessage({ id: 'agentproductivity.dashboard.csat.result', defaultMessage: 'Resultado CSAT' })}
      scoreLabel={intl.formatMessage({ id: 'agentproductivity.dashboard.csat.score', defaultMessage: 'CSAT SCORE' })}
      scoreValue={score}
      scoreColor={getScoreColor(parseFloat(score))}
      rows={rows}
      icon={<SentimentSatisfiedAltIcon />}
      accentColor={colors.primary}
      tooltip={intl.formatMessage({ id: 'agentproductivity.dashboard.csat.tooltip', defaultMessage: 'CSAT mede a satisfação do cliente com o atendimento — média ponderada das notas de 1 (muito ruim) a 5 (muito bom) dadas nos chamados do período.' })}
    />
  );
});

export default injectIntl(CsatTable);
